import React from 'react'

function HR_Review_Program_Page() {
  return (
    <div>
    <div>
      <div className='container'>
      <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-5 pb-2'>Testmonial</h1>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
        <div className='row'>
            <div className='col-md-4 pt-5'>
                <div className='Program_review_comp p-5'>
                    <div className='mt-5'>
                        <h1 className='pt-5 display-6 review_component_text'>Hear What Our Students Says</h1>
                        <p className='pt-4 fs-5'>10,000+ Students have already learned with InternsElite</p>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className='row'>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Shubham Choudhary</h5>
                    <h6 class="font-weight-bold my-2">G H Raisoni College of Engineering and Technology Nagpur, BCA </h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>This team can provide a knowledge and helpful for future and the most important thing is learn way
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Anushka Raj</h5>
                    <h6 class="font-weight-bold my-2">Graphic Era Deemed to be University, BBA</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>It was very innovative and encouraging program. It help us to motivate and give the best result for the subject we have indulged in. Feeling very motivated by attending this training program.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Eshika Garg</h5>
                    <h6 class="font-weight-bold my-2">NMIMS, MBA</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="mb-2">
                    <i class="fas fa-quote-left pe-2"></i>Internslite's live lectures provided an excellent learning experience, allowing real-time doubt clarification. The training teacher, especially, enriched our understanding of the corporate world effectively.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Hritik</h5>
                    <h6 class="font-weight-bold my-2">JCBOSE university os Science and Technologyy, (Management)</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Overall training session was good, all basic concepts were discussed a student can gain insights of HR from base and can enhance his career in this field
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Vaishnavi Singh</h5>
                    <h6 class="font-weight-bold my-2">Babu Banarasi Das University</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>My experience was overall good. It is a great learning platform and provide quality education and training programs. Otherwise everything was on the mark.
                    </p>
                </div>
                </div>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Akanksha</h5>
                    <h6 class="font-weight-bold my-2">JBU Science and Technology YMCA, faridabad, (Management) </h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>This course is very helpful as it increases our knowledge and skills and it also provide us two live projects in our training period.
                    </p>
                </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default HR_Review_Program_Page
